import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { AtividadeTipoPipeModule } from '../../tipo/pipes';

import { AtividadeRefCardInfoComponent } from './atividade-ref-card-info.component';

@NgModule({
    imports: [
        SharedModule,
        AtividadeTipoPipeModule
    ],
    declarations: [
        AtividadeRefCardInfoComponent
    ],
    exports: [
        AtividadeRefCardInfoComponent
    ]
})
export class AtividadeRefCardInfoModule { }
